import { spacing } from '@chegg-ui/theme'
import { Advert as UnstyledAdvert } from '@chegg-wt/core/components/Advert'
import styled from 'styled-components'
import { themeBreakPoints } from '@chegg-wt/core/theme/theme'

export const PaperContainer = styled.div.attrs({
  role: 'region',
  'aria-label': 'Bibliography Module',
})`
  background: ${({ theme }) => theme.Colors.forInterface.interfaceColor11};
  min-height: 200px;
  min-width: 284px;
  box-shadow: 0 0 4px 0 rgba(34, 34, 34, 0.24);
  padding: ${spacing.px24} ${spacing.px4};
`

export const Advert = styled(UnstyledAdvert)`
  margin-top: ${({ theme }) => theme.spacing.lg};
`

export const WidgetContainer = styled.div.attrs({
  role: 'region',
  'aria-label': 'Upload Widget',
})`
  background: ${({ theme }) => theme.Colors.forInterface.interfaceColor11};
  box-shadow: 0 0 4px 0 rgba(34, 34, 34, 0.24);
  padding: ${spacing.px4} ${spacing.px32} ${spacing.px16};
  margin-top: ${spacing.px24};
`

export const PlagiarismCardContainer = styled(PaperContainer)`
  margin-top: ${spacing.px16};
`

export const Wrapper = styled.div`
  @media (max-width: ${({ theme }) => themeBreakPoints.extraSmall(theme)}) {
    padding: ${spacing.px16};
  }
`

export const InnerWrapper = styled.div`
  padding: 0 ${spacing.px8};
`

export const CreateAccountBannerContainer = styled.div`
  margin-top: ${spacing.px16};
`
